import * as React from 'react';
import { Button } from '@cian/ui-kit';

import { Trash16 } from '@cian/ui-kit/icons';
import { ModalConfirmRemoveAllContainer } from './ModalConfirmRemoveAllContainer';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedProducts } from '../../../selectors/selected';
import { ModalConfirmRemoveContainer } from './ModalConfirmRemoveContainer';
import { trackRemoveAllClick, trackRemoveClick } from './tracking';
import { selectSelectedFolder } from '../../../selectors/folders';
import { ModalConfirmRemoveFromFolderContainer } from './ModalConfirmRemoveFromFolderContainer';
import { isHideModalConfirmRemoveFromFavorites } from '../../../utils/remove';
import { removeByIds } from '../../../thunk/favorites';

export function RemoveContainer() {
  const dispatch = useDispatch();
  const [isConfirmModalVisible, setConfirmModalVisible] = React.useState(false);
  const selectedProducts = useSelector(selectSelectedProducts);
  const selectedFolder = useSelector(selectSelectedFolder);
  const selectedCount = selectedProducts.length;

  const handleClick = () => {
    if (selectedCount) {
      trackRemoveClick(selectedProducts);
      if (!selectedFolder && isHideModalConfirmRemoveFromFavorites()) {
        dispatch(removeByIds());

        return;
      }
    } else {
      trackRemoveAllClick();
    }
    setConfirmModalVisible(true);
  };

  const handleClose = () => {
    setConfirmModalVisible(false);
  };

  let modal;
  if (selectedFolder) {
    modal = <ModalConfirmRemoveFromFolderContainer onClose={handleClose} />;
  } else {
    modal = selectedCount ? (
      <ModalConfirmRemoveContainer onClose={handleClose} />
    ) : (
      <ModalConfirmRemoveAllContainer onClose={handleClose} />
    );
  }

  return (
    <React.Fragment>
      {isConfirmModalVisible && modal}
      <Button beforeIcon={<Trash16 color="primary_100" />} size="XS" theme="fill_white_primary" onClick={handleClick}>
        {selectedCount ? 'Удалить' : 'Удалить все'}
      </Button>
    </React.Fragment>
  );
}
